export const ALLOWED_EXTENSION = 'application/json';
